import actionTypes from './action-types';
import * as api from '../resources/message.api';

export const replyMessageRequest = () => ({
  type: actionTypes.REPLY_MESSAGE_REQUEST,
});

export const replyMessageFailure = () => ({
  type: actionTypes.REPLY_MESSAGE_FAILURE,
});

export const replyMessageSuccess = () => ({
  type: actionTypes.REPLY_MESSAGE_SUCCESS,
});

export const replyMessage = (message) => async (dispatch) => {
  try {
    dispatch(replyMessageRequest());
    await api.replyMessage(message);

    dispatch(replyMessageSuccess());
  } catch (error) {
    dispatch(replyMessageFailure(error));
    throw new Error(`REPLY_MESSAGE: ${error}`);
  }
};



// WEBPACK FOOTER //
// ./src/modules/message/actions/reply-message.actions.js